(() => {
  const configured = new WeakSet();
  const subscriberSections = new Set([
    'cart-drawer:cart-drawer',
    'cart-drawer-items:CartDrawer',
    'cart-items:main-cart-items',
    'cart-items:CartDrawer',
    'cart-drawer-items:main-cart-items',
  ]);

  function collectCartSections() {
    const sections = new Map();
    for (const element of document.querySelectorAll('cart-drawer,cart-items,cart-drawer-items,cart-notification')) {
      const entries = element.getSectionsToRender?.() || [];
      for (const entry of entries) {
        if (subscriberSections.has(`${element.tagName.toLowerCase()}:${entry.id}`)) continue;
        const sectionId = entry.section || entry.id;
        if (!sectionId || sections.has(sectionId)) continue;
        const root = entry.section ? document.getElementById(entry.id) : document;
        if (!root) continue;
        const mount = entry.selector
          ? root.querySelector(entry.selector) || (entry.section ? root : null)
          : document.getElementById(entry.id);
        if (mount) sections.set(sectionId, { mount, selector: entry.selector || '.shopify-section' });
      }
    }
    return sections;
  }

  async function refreshDawnCartUI() {
    const sections = collectCartSections();
    const cartUrl = window.routes?.cart_url || '/cart';
    const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart refresh request failed');
    const cartData = await response.json();
    if (!Array.isArray(cartData?.items) || !Number.isInteger(cartData.item_count) || !cartData.currency) {
      throw new Error('Invalid cart refresh response');
    }
    if (sections.size) {
      const query = `?sections=${encodeURIComponent([...sections.keys()].join(','))}`;
      const sectionResponse = await fetch(`${cartUrl}${query}`, { headers: { Accept: 'text/html' } });
      if (!sectionResponse.ok) throw new Error('Cart section refresh request failed');
      cartData.sections = await sectionResponse.json();
    }
    const replacements = [];
    for (const [id, { mount, selector }] of sections) {
      const html = cartData.sections?.[id];
      const source = typeof html === 'string' && new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      if (!source) throw new Error(`Cart refresh section missing: ${id}`);
      replacements.push({ mount, source });
    }
    for (const { mount, source } of replacements) mount.replaceChildren(...source.childNodes);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cartData.item_count === 0);
    await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-refresh', cartData });
  }

  function initialize() {
    const actions = window.Shopify?.actions;
    if (actions?.openCart?.configure && !configured.has(actions.openCart)) {
      actions.openCart.configure({
        async handler(defaultHandler) {
          const drawer = document.querySelector('cart-drawer');
          if (typeof drawer?.open === 'function') return drawer.open(document.activeElement);
          return defaultHandler();
        },
      });
      configured.add(actions.openCart);
    }
    if (actions?.updateCart?.configure && !configured.has(actions.updateCart)) {
      actions.updateCart.configure({
        eventTarget: () => document,
        async handler(defaultHandler) {
          const result = await defaultHandler();
          try {
            await refreshDawnCartUI();
          } catch (error) {
            console.error('[Dawn] Cart refresh failed; reloading.', error);
            window.location.reload();
          }
          return result;
        },
      });
      configured.add(actions.updateCart);
    }
  }
  initialize();
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('lc:standard-events-ready', initialize, { once: true });
  window.addEventListener('load', initialize, { once: true });
})();
